module.exports = __webpack_public_path__ + "img/stats.d8c3708f.svg";